module.exports = "/img/_/_/_/assets/images/creeper/book/legendary//3.jpg?d297c57d14f525a65292ae0d5abf2189";